import { render, staticRenderFns } from "./Changelogs.vue?vue&type=template&id=1d44a216&"
import script from "./Changelogs.vue?vue&type=script&lang=js&"
export * from "./Changelogs.vue?vue&type=script&lang=js&"
import style0 from "./Changelogs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports